import Enum from 'enum';

export const main = new Enum(
    {
        REVIEW: 0,
        ENABLED: 1,
        DISABLED: 2,
        LOCKED: 3,
    },
    {freeze: true}
);

export const enumToCode = enumItem => (
    !enumItem || !main.isDefined(enumItem) ?
        undefined :
        enumItem.value
);

export const codeToEnum = code => (
    !Number.isSafeInteger(code) ?
        undefined :
        main.get(code)
);
